import React from "react";

function SpaToken() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      fill="none"
      viewBox="0 0 40 40"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.8315 2.177C17.6659 -0.725665 22.3341 -0.725665 25.1685 2.177L26.7231 3.76909L28.9481 3.74258C33.0048 3.69426 36.3057 6.99522 36.2574 11.0519L36.2309 13.2769L37.823 14.8315C40.7257 17.6659 40.7257 22.3341 37.823 25.1685L36.2309 26.7231L36.2574 28.9481C36.3057 33.0048 33.0048 36.3057 28.9481 36.2574L26.7231 36.2309L25.1685 37.823C22.3341 40.7257 17.6659 40.7257 14.8315 37.823L13.2769 36.2309L11.0519 36.2574C6.99522 36.3057 3.69426 33.0048 3.74258 28.9481L3.76909 26.7231L2.177 25.1685C-0.725665 22.3341 -0.725665 17.6659 2.177 14.8315L3.76909 13.2769L3.74258 11.0519C3.69426 6.99522 6.99522 3.69426 11.0519 3.74258L13.2769 3.76909L14.8315 2.177ZM20.06 10C22.18 12.12 23.31 14.84 23.49 17.63C22.21 18.32 21.03 19.2 20 20.26C18.97 19.19 17.79 18.31 16.51 17.63C16.74 14.86 17.92 12.14 20.06 10ZM16.9334 20.2407C16.9526 20.2537 16.9715 20.2668 16.99 20.28C16.974 20.2686 16.9577 20.2574 16.9412 20.2464C18.1438 21.1146 19.1819 22.202 20 23.45C22.15 20.17 25.82 18 30 18C30 23.32 26.64 27.82 21.97 29.49C21.33 29.71 20.68 29.88 20 30C19.32 29.89 18.66 29.72 18.03 29.49C13.36 27.82 10 23.32 10 18C12.5861 18 14.9769 18.8306 16.9334 20.2407Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SpaToken;
